<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="EPI">As far as the laws of mathematics refer to reality, they are not certain; and as far as they are certain, they do not refer to reality.</p>
<p class="EPC">—Albert Einstein, <span class="ePub-I">Sidelights on Relativity</span> (1922)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?28d011a4